ACC.formatChooser = {
    _autoload: [
        'initComponent',
    ],

    initComponent() {
        $(document).ready(() => {
            const name = 'FormatChooser';
            const $component = $(`[data-component=${name}]`);

            if (!$component.length) {
                return;
            }

            this.start($component);
        });
    },

    start($el) {
        this.initElements($el);
        this.initEvents();
        this.preselectFormat();
    },

    initElements($el) {
        this.preferredCardContainer = $el.find('.js-card-list');
        this.formatCards = $el.find('.js-format-card');
        this.allProducts = $el.find('.recommended-card');
    },

    initEvents() {
        this.preferredCardContainer.on('keypress click', '.js-format-card', this.handlerFormatClick);
    },

    findFormatToPreselect() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('format')) {
            const format = urlParams.get('format');
            return ACC.formatChooser.formatCards.filter(function () {
                return $(this).attr('id') === format;
            });
        }

        return $(ACC.formatChooser.formatCards[0]);
    },

    isFormatSingleInLine($format) {
        return ($format.width() / this.preferredCardContainer.width()) > 0.5;
    },

    preselectFormat() {
        const $formatToPreselect = ACC.formatChooser.findFormatToPreselect();
        if (!ACC.formatChooser.isFormatSingleInLine($formatToPreselect)) {
            ACC.formatChooser.selectFormat($formatToPreselect);
        }
    },

    handlerFormatClick(event) {
        event.preventDefault();
        ACC.formatChooser.selectFormat($(event.currentTarget));
    },

    selectFormat($format) {
        ACC.formatChooser.preferredCardContainer.find('.isActive')
            .filter(function () {
                return $(this).attr('id') !== $format.attr('id');
            })
            .toggleClass('isActive');
        $format.toggleClass('isActive');
        ACC.formatChooser.updateRecommendedProducts();
    },

    findProductsToShow() {
        const activeCards = this.preferredCardContainer.find('.isActive');
        const activeFormats = $.map(activeCards, (card) => card.id);

        return this.allProducts.filter(function () {
            return activeFormats.indexOf($(this).data('product-format')) !== -1;
        });
    },

    updateRecommendedProducts() {
        ACC.formatChooser.allProducts.hide().removeClass('recommended-card--even');

        ACC.formatChooser.findProductsToShow()
            .each((index, product) => {
                if (index % 2 === 0) {
                    $(product).addClass('recommended-card--even');
                }
            }).show();
    },
};
